import React from 'react';
import styled from 'styled-components';
import { formatBrandingTextToHtml } from '../../utils/formatBrandingTextToHtml';

const FormattedText = styled.div`
    font-size: 14px;
    line-height: 1.5;

    p {
        margin: 0 0 16px 0;

        &:last-child {
            margin-bottom: 0;
        }
    }
`;

export default function BrandingFormattedText({ text }) {
    if (!text) return null;

    return (
        <FormattedText
            dangerouslySetInnerHTML={{
                __html: formatBrandingTextToHtml(text),
            }}
        />
    );
}
